var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiativeDetailFinancial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear_financial)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_financial)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 15.375H22.75L21.0836 12.8754C20.834 12.4992 21.1012 12 21.5512 12H28.4488C28.8988 12 29.166 12.4992 28.9164 12.8754L27.25 15.375ZM22.75 16.5H27.25C27.3836 16.5879 27.5348 16.6863 27.707 16.7953C29.7004 18.0715 34 20.8207 34 26.625C34 28.4883 32.4883 30 30.625 30H19.375C17.5117 30 16 28.4883 16 26.625C16 20.8207 20.2996 18.0715 22.293 16.7953C22.4617 16.6863 22.6164 16.5879 22.75 16.5ZM25.7031 19.5938C25.7031 19.207 25.3867 18.8906 25 18.8906C24.6133 18.8906 24.2969 19.207 24.2969 19.5938V20.0859C24.0297 20.1457 23.7625 20.2406 23.5164 20.3848C23.0277 20.6766 22.6059 21.1863 22.6094 21.9281C22.6129 22.6418 23.0313 23.0918 23.4777 23.359C23.8645 23.591 24.3461 23.7387 24.7293 23.8512L24.7891 23.8687C25.232 24.0023 25.5555 24.1078 25.7734 24.2449C25.9527 24.3574 25.9773 24.4348 25.9809 24.5332C25.9844 24.709 25.9176 24.8145 25.7734 24.9023C25.5977 25.0113 25.3199 25.0781 25.0211 25.0676C24.6309 25.0535 24.2652 24.9305 23.7871 24.7688C23.7062 24.7406 23.6219 24.7125 23.534 24.6844C23.1648 24.5613 22.7676 24.7617 22.6445 25.1273C22.5215 25.4965 22.7219 25.8938 23.0875 26.0168C23.1543 26.0379 23.2281 26.0625 23.302 26.0906C23.5938 26.1926 23.9313 26.3086 24.2934 26.3859V26.9062C24.2934 27.293 24.6098 27.6094 24.9965 27.6094C25.3832 27.6094 25.6996 27.293 25.6996 26.9062V26.4211C25.9809 26.3613 26.2621 26.2629 26.5152 26.1047C27.018 25.7918 27.3977 25.2574 27.3871 24.5227C27.3766 23.809 26.9758 23.3484 26.5223 23.0602C26.118 22.807 25.6117 22.6523 25.218 22.5328L25.1934 22.5258C24.7434 22.3887 24.4234 22.2902 24.1984 22.1566C24.0156 22.0477 24.0121 21.9844 24.0121 21.9211C24.0121 21.791 24.0613 21.6926 24.2301 21.5941C24.4199 21.4816 24.7082 21.4148 24.9859 21.4184C25.3234 21.4219 25.6961 21.4957 26.0828 21.6012C26.459 21.6996 26.8422 21.4781 26.9441 21.102C27.0461 20.7258 26.8211 20.3426 26.4449 20.2406C26.2164 20.1809 25.9633 20.1211 25.7031 20.0754V19.5938Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_financial",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_financial",
    x1: 5,
    y1: 1,
    x2: 45,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054254"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiativeDetailFinancial);
export default __webpack_public_path__ + "static/media/initiative-detail-financial.d859484dbeafdfeaef2c901c1d5f1ab4.svg";
export { ForwardRef as ReactComponent };